var v1="<div class=\"chart\"></div>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("dashboard/fairway-hit/fairway-hit-chart.jade", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ngapp/javascript/web/dashboard/fairway-hit/fairway-hit-chart.jade
// module id = 568
// module chunks = 0